import React from 'react'
import './EasterEggLoader.css'

const EasterEggLoader: React.FC = () => (
  <div className="easter-egg-loader">
    <div className="easter-egg-spinner" />
  </div>
)

export default EasterEggLoader
